import React, { useContext } from "react";
import { StripedList } from "../bookmarks/BookmarkPage";
import { Bookmark } from "../bookmarks/BookmarksProvider";
import ParagraphDefault from "../common/Paragraph";
import { font, colors, media, breakpoints, fontSizing } from "../theme";
import styled, { css } from "styled-components";
import BookmarkButton from "../bookmarks/BookmarkButton";
import Content from "../common/Content";
import Link from "../utils/Link";
import { Link as LinkIcon } from "../common/icons";
import A from "../common/A";
import GlobalContext from "../context/GlobalContext";

const maxLength = {
  default: 200,
  mobile: 100
};

export const rowStyle = css`
  padding-top: 24px;
  padding-bottom: 24px;

  @media ${media.mobile} {
    padding-top: 32px;
    padding-bottom: 32px;
  }
  &:first-child {
    padding-top: 0px;
  }
  &:last-child {
    padding-bottom: 0;
  }
`;

const Paragraph = styled(ParagraphDefault)`
  font-weight: ${font.weightRegular};
  font-size: ${font.sizeXXS};
  color: ${colors.blue};
  line-height: 28px;
  margin-bottom: 0;
  max-width: ${breakpoints.desktop}px;
`;

const ATag = styled(A)`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  & > svg {
    margin-right: 25px;
    width: 25px;
    height: 25px;
    flex-shrink: 0;
    color: ${colors.pigeonLight};
    @media ${media.desktop} {
      margin-top: 6px;
    }
  }
`;

const Title = styled.span`
  ${fontSizing("headline", 24)}
  font-weight: normal;
  line-height: 1.5;
  text-decoration: underline;
  text-decoration-color: ${colors.pigeonLight};
  text-underline-position: under;
  margin: 0;
  margin-bottom: calc(4px * 5);
  max-width: ${breakpoints.desktop}px;
  @media ${media.mobile} {
    margin-bottom: calc(4px * 4);
  }
`;

const Container = styled(Content)`
  display: flex;
  flex-direction: row;
  @media ${media.mobile} {
    display: block;
  }
`;
const Spacer = styled.div`
  flex: 1;
  @media ${media.mobile} {
    margin-bottom: 24px;
  }
`;

const ResultListItem = styled(StripedList).attrs({ as: "li" })`
  list-style: none;
`;

const Button = styled(BookmarkButton)`
  margin-left: 50px;

  @media screen and ${media.superTinyZoom125} {
    margin: auto;
    display: block;
  }
`;
type Props = Bookmark & {
  description: string;
};
export default function PageResult(props: Props) {
  const { theme } = useContext(GlobalContext);
  const { description, ...rest } = props;

  const max = theme.isMobile ? maxLength.mobile : maxLength.default;
  const des = description
    ? `${description.slice(0, max)}${description.length > max ? "..." : ""}`
    : "";

  return (
    <ResultListItem>
      <Container padded>
        <Spacer>
          <Link href={props.href}>
            <ATag tabIndex={0}>
              <LinkIcon aria-hidden={"true"} />
              <div>
                <Title id={rest.id}>{props.title}</Title>
                {des && <Paragraph as="p">{des}</Paragraph>}
              </div>
            </ATag>
          </Link>
        </Spacer>
        <div>
          <Button
            id={`${rest.id}_bookmark_cta`}
            // see suggestion of https://report.bitvtest.de/51c6ded0-9ca7-4305-b76d-7400cccfa873.html#checkpoint-3e9f161271-v2-n2
            // see IFB-1100
            aria-labelledby={`${rest.id} ${rest.id}_bookmark_cta`}
            tiny
            wide
            activeText={"Entfernen"}
            bookmark={rest}
            isDownload={false}
          >
            Merken
          </Button>
        </div>
      </Container>
    </ResultListItem>
  );
}
